
import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';
import { SpotlightData } from './types';

interface SpotlightSectionProps {
  spotlight: SpotlightData;
  onLinkClick: (href: string, e: React.MouseEvent) => void;
}

export const SpotlightSection: React.FC<SpotlightSectionProps> = ({ spotlight, onLinkClick }) => {
  return (
    <div className="flex-1 px-6 py-4 flex flex-col justify-start items-start bg-gradient-to-b from-white/99 to-gray-50 relative min-w-[320px] gap-2">
      <div className="w-full">
        <div className="flex items-center mb-3">
          <spotlight.icon className="w-8 h-8 text-gray-900 mr-3" />
          <span className="text-xl font-semibold text-gray-800 tracking-tight">{spotlight.name}</span>
        </div>
        <span className="block text-sm font-medium text-blue-600 mb-2 tracking-wide">{spotlight.tagline}</span>
        <p className="text-sm text-gray-700 mb-3 leading-relaxed max-w-sm">{spotlight.description}</p>
        <button
          onClick={(e) => onLinkClick(spotlight.href, e)}
          className="text-sm px-6 py-2 shadow-sm bg-gradient-to-r from-blue-600 to-cyan-600 hover:from-blue-700 hover:to-cyan-700 text-white font-semibold transition-all duration-150 rounded inline-flex items-center"
        >
          {spotlight.cta}
          <ArrowRight className="ml-2 w-4 h-4" />
        </button>
        {spotlight.image && (
          <img
            src={spotlight.image}
            alt={spotlight.name}
            className="mt-4 w-full object-cover max-h-28 shadow-xl border border-gray-100"
            style={{ objectFit: 'cover' }}
          />
        )}
        
        {/* Price Beat Guarantee Box with reduced height to align with blog box */}
        <div
          onClick={(e) => onLinkClick('/price-beat-guarantee', e)}
          className="mt-3 w-full p-3 bg-green-100/70 border border-green-400 hover:border-green-500 hover:bg-green-100/90 transition-all duration-200 flex items-center gap-3 text-left h-24 cursor-pointer"
        >
          <Shield className="w-5 h-5 text-green-600 group-hover:text-green-700 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <h3 className="font-medium text-gray-900 hover:text-green-900 text-sm">Price Beat Guarantee</h3>
            <p className="text-xs text-gray-600 hover:text-gray-700 leading-relaxed">
              We guarantee to beat and competitor's price by 25% or we will give you £1000. 
              <span 
                onClick={(e) => {
                  e.stopPropagation();
                  onLinkClick('/price-beat-guarantee', e);
                }}
                className="text-green-700 hover:text-green-800 cursor-pointer"
              >
                T&C's Apply
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
